import React, { Suspense } from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

const ProtectRoute = ({ route, children }) => {
  const { role, userInfo } = useSelector((state) => state.auth)

  if (!role) {
    return <Navigate to="/admin/login" replace />
  }
  if (!userInfo) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        Loading...
      </div>
    )
  }
  if (route.role && userInfo.role?.trim() !== route.role) {
    return <Navigate to="/unauthorized" replace />
  }
  return <Suspense fallback={null}>{children}</Suspense>
}

export default ProtectRoute
